import { SpaceBetween } from '@cloudscape-design/components';
import { ValueWithLabel } from '../../components/ValueWithLabel';

/**
 * Renderiza resultados de prompts con soporte para campos anidados.
 *
 * @param {Object} props
 * @param {Array} props.results - Array de { label, value, fullKey, isNested, children? }
 * @param {string} props.noSummaryText
 * @param {string} props.category
 * @param {(value: string, context: { category: string, baseKey: string }) => import('react').ReactNode} props.formatValue
 */
export function NestedPromptResults({ results, noSummaryText, category, formatValue }) {
  if (!results || results.length === 0) {
    return <ValueWithLabel key='nosummary'>{noSummaryText}</ValueWithLabel>;
  }

  const inlineLabelCategories = new Set(['QualityEvaluation', 'VOCSummary']);
  const inlineLabels = inlineLabelCategories.has(category);

  const renderValue = (value, fullKey) => {
    if (!formatValue || typeof value !== 'string') {
      return value;
    }

    if (inlineLabels && !value.includes('\n')) {
      return value;
    }

    return formatValue(value, { category, baseKey: fullKey });
  };

  const renderEntry = (entry, key) => {
    if (entry.isNested && entry.children) {
      return (
        <ValueWithLabel key={key} label={entry.label}>
          <SpaceBetween size="s">
            {entry.children.map((child, childIndex) => renderEntry(child, childIndex))}
          </SpaceBetween>
        </ValueWithLabel>
      );
    }

    return (
      <ValueWithLabel key={key} label={entry.label}>
        <div style={{ whiteSpace: 'pre-line' }}>
          {renderValue(entry.value, entry.fullKey)}
        </div>
      </ValueWithLabel>
    );
  };

  const rendered = results.map((entry, i) => renderEntry(entry, i));

  return inlineLabels ? (
    <SpaceBetween size="l">
      {rendered}
    </SpaceBetween>
  ) : rendered;
}

export default NestedPromptResults;
